import { useState } from "react";
import Modal from "../components/Modal";

const useModal = () => {
    const [showModal, setShowModal] = useState(false);
    const [ModalComponent, setModalComponent] = useState(null);

    const handleShowModal = ({ closeAction = () => {}, children, ...modalProps }) => {
        const handleCloseAction = () => {
            closeAction();
            setShowModal(false);
        };
        
        setModalComponent(<Modal closeAction={handleCloseAction} {...modalProps}>{children}</Modal>);
        setShowModal(true);
    };

    return [
        showModal ? ModalComponent : <></>,
        handleShowModal,
    ];
};

export default useModal;
